const Resources = {
    breadcrumb: [
        {
            name: "Home",
            href: "/",
            arrow: "<span class='slash'>/</span>",
        },
        {
            name: "Reports",
            href: "/reports",
            arrow: "<span class='slash'>/</span>",
        },
    ],

    

    table_headers: [
        {
            text:   'Cost Center',
            value:  'name',
            report_value: 'name',
            type:   '',
            show: true,
            order: 0,
            style: "width: 30%"

        },
        {
            text:   'Cost Center #',
            value:  'cost_center',
            report_value: 'cost_center',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"

        },
        {
            text:   'Annual Daily Hrs',
            value:  'annual_daily_hours',
            report_value: 'annual_daily_hours',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'Annual Project Hrs',
            value:  'annual_project_hours',
            report_value: 'annual_project_hours',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'Annual Hrs',
            value:  'total_annual_hours',
            report_value: 'total_annual_hours',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'Annual Hrs %',
            value:  'annual_hours_percentage',
            report_value: 'annual_hours_percentage',
            type:   '',
            show: true,
            order: 0,
            style: "width: 7%"
        },
        {
            text:   'SQ FT',
            value:  'total_sq_ft',
            report_value: 'total_sq_ft',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'SQ FT %',
            value:  'total_sq_ft_percentage',
            report_value: 'total_sq_ft_percentage',
            type:   '',
            show: true,
            order: 0,
            style: "width: 5%"

        },
    ],

    table_headers_building_room_usage_report: [
        {
            text:   'Room Usage',
            value:  'description',
            report_value: 'description',
            type:   '',
            show: true,
            order: 0,
            style: "width: 20%"

        },
        {
            text:   '# of Rooms',
            value:  'total_rooms',
            report_value: 'total_rooms',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"

        },
        {
            text:   'SQ FT',
            value:  'sq_ft',
            report_value: 'sq_ft',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%"
        },
        {
            text:   'SQ FT %',
            value:  'sq_ft_percentage',
            report_value: 'sq_ft_percentage',
            type:   '',
            show: true,
            order: 0,
            style: "width: 8%"
        },
        {
            text:   'Yearly Hours',
            value:  'yearly_hours',
            report_value: 'yearly_hours',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%"
        },
        {
            text:   'Yearly Hours %',
            value:  'yearly_hours_percentage',
            report_value: 'yearly_hours_percentage',
            type:   '',
            show: true,
            order: 0,
            style: "width: 10%"
        },
        {
            text:   'FTE',
            value:  'ftes',
            report_value: 'ftes',
            type:   '',
            show: true,
            order: 0,
            style: "width: 7%"
        },
    ],
}

export default Resources;